<script>
</script>

<main>
  <section class="text-aling-center my-5 py-5">
    <h1 class="text-secondary">Armeria</h1>
    <h1 class="text-secondary">FrontEnd</h1>
  </section>
</main>

<style>
</style>
